import React, { useContext } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useQuery } from "../../../../../utils/CustomHooks/UseQuery";
import banner_FR from "../../../../../assets/images/easySetup/banner/FR_EcoPro.jpg";
import banner_EN from "../../../../../assets/images/easySetup/banner/EN_EcoPro.jpg";
import banner_IT from "../../../../../assets/images/easySetup/banner/IT_EcoPro.jpg";
import banner_NL from "../../../../../assets/images/easySetup/banner/NL_EcoPro.jpg";
import banner_DE from "../../../../../assets/images/easySetup/banner/DE_EcoPro.jpg";
import banner_DA from "../../../../../assets/images/easySetup/banner/DA_EcoPro.jpg";
import banner_ES from "../../../../../assets/images/easySetup/banner/ES_EcoPro.jpg";
import banner_FI from "../../../../../assets/images/easySetup/banner/FI_EcoPro.jpg";
import banner_PT from "../../../../../assets/images/easySetup/banner/PT_EcoPro.jpg";
import banner_SV from "../../../../../assets/images/easySetup/banner/SV_EcoPro.jpg";
import sixMonthBannerImg from "../../../../../assets/images/easySetup/six-month-trial.png"
import Loader from "../../../../../components/shared/loader/Loader";
import "./DesktopBenefitOfSuppliesOldVersion.css";
import { IsHWIncServiceNativeApp } from "../../../../../constants/AppMethod";
import { BMC_SHENLONG_SERVICE_TYPES, featureSwitchName, BONUS_PAGE_COUNT } from "../../../../../constants/AppConstants";
import HardwareInclusiveContent from "../../../Shared/HardwareInclusiveContent";
import { shenlongPageDisplayInfoContext } from "../../../Shared/BenefitOfSuppliesMain";
import LearnMore from "../../../Shared/LearnMore/LearnMore";

const DesktopBenefitOfSuppliesOldVersion = (props) => {
  const { t } = useTranslation(["translation"]);
  const isHWInc = IsHWIncServiceNativeApp();
  const {
      featureSwitchLoading,
      featureSwitchValues
    }  = useContext(shenlongPageDisplayInfoContext);

    const PromotionBanners = featureSwitchValues?.[featureSwitchName.PROMOTION_BANNERS];
    const BonusPages = featureSwitchValues?.[featureSwitchName.BONUS_PAGES];
  
  const queryParams = useQuery();
  const languageCode = queryParams.get("language");

  const imageUrlCountry = {
    EN: banner_EN,
    DE: banner_DE,
    FR: banner_FR,
    IT: banner_IT,
    NL: banner_NL,
    DA: banner_DA,
    ES: banner_ES,
    FI: banner_FI,
    PT: banner_PT,
    SV: banner_SV,
  };

  const getImagesOnCountryCode = () => {
    if (languageCode) {
      return imageUrlCountry[languageCode.toUpperCase()];
    }
  };

  if (featureSwitchLoading) {
    return <Loader></Loader>;
  }

  return (PromotionBanners || BonusPages) ? (
    <>
      <div className="easy-setup-six-months-banner-container">
        <div className="column-a">
          <img src={sixMonthBannerImg} alt="banner" />
        </div>
        <div className="column-b-six-month-promotion">
          {
            (isHWInc)
            ? <HardwareInclusiveContent />
            : <div>
                <h1 className="header-2">
                  {
                    (PromotionBanners || BonusPages)
                      ?
                      <>
                        {PromotionBanners
                          ?
                          <>
                            {BonusPages ?

                              <>
                                <p  className="bonus-savemore">{t("PROMOTION_BANNER.SAVE_MORE")}</p>
                                <Trans i18nKey="EASY_SETUP.SIX_MONTH_PROMOTION.HEADER_2">
                                  Get a 6 months
                                  <span className="free-trial">FREE EcoPro trial</span>
                                </Trans>
                                <span>{t("EASY_SETUP.BONUS_PAGES.PAGES_FREE_COUNT", {pageCount:BONUS_PAGE_COUNT})}</span>
                              </>
                              :
                              <>
                                <p  className="bonus-savemore">{t("EASY_SETUP.SIX_MONTH_PROMOTION.HEADER_1")}</p>
                                <Trans i18nKey="EASY_SETUP.SIX_MONTH_PROMOTION.HEADER_2">
                                  Get a 6 months
                                  <span className="free-trial">FREE EcoPro trial</span>
                                </Trans>
                              </>

                            }
                          </>

                          :
                          <>
                            {
                              BonusPages ?
                                <>
                                  <p className="bonus-savemore">{t("PROMOTION_BANNER.SAVE_MORE")}</p>
                                  <div>{t("PROMOTION_BANNER.TWO_OR_FOUR_MONTHS_PROMOTION")} </div>
                                  <div>{t("EASY_SETUP.BONUS_PAGES.PAGES_FREE_COUNT", {pageCount:BONUS_PAGE_COUNT})} </div>
                                </>
                                :
                                <>
                                <div>{t("PROMOTION_BANNER.TWO_OR_FOUR_MONTHS_PROMOTION")} </div>
                                </>
                            }
                          </>
                        }
                      </>
                      :
                      <>
                      </>
                  }
                </h1>
                <p>{t("EASY_SETUP.SIX_MONTH_PROMOTION.SUB_HEADER")}</p>
                <ul className="bullet-points">
                  <li>{t("EASY_SETUP.BANNER.LINE2")}</li>
                  <li>{t("EASY_SETUP.BANNER.LINE3")}</li>
                  <li>{t("EASY_SETUP.BANNER.LINE4")}</li>
                </ul>
              </div>
          }
        </div>
      </div>
    </>
  ) : (
    <div className="easy-setup-banner-container">
      <div className="column-a">
        <img src={getImagesOnCountryCode()} alt="banner" />
      </div>
      <div className="column-b-banner">
        {
          (isHWInc)
          ? <HardwareInclusiveContent />
          : <div>
            <h1>{t("EASY_SETUP.BANNER.HEADER")}</h1>
            <p className="twomonths_text">
              <div>{t("PROMOTION_BANNER.TWO_OR_FOUR_MONTHS_PROMOTION")} </div>
            </p>
            <p>{ BonusPages ? t("EASY_SETUP.BANNER.LINE1_BONUS") : t("EASY_SETUP.BANNER.LINE1") }</p>
            <p>{t("EASY_SETUP.BANNER.LINE2")}</p>
            <p>{t("EASY_SETUP.BANNER.LINE3")}</p>
            <p>{t("EASY_SETUP.BANNER.LINE4")}</p>
            <div className="learn-more-link">
              <LearnMore type={BMC_SHENLONG_SERVICE_TYPES.ECOPRO}/>
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default DesktopBenefitOfSuppliesOldVersion;

